export default __webpack_public_path__ + "static/media/total_paid_icon.990d94f0.svg";